<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">
    <h1 class="questions__header">{{ $t("Allowances") }}</h1>
    <h2 v-show="contractsEmpty" class="questions__subheader questions__inputerrordescription">
      {{ $t("Please fill in the contract details first to proceed to this page.") }}</h2>

    <div v-if="!contractsEmpty">
      <h2 class="questions__subheader">{{ $t("Do you use allowances?") }}</h2>
      <b-form-checkbox
        v-model="allowancesEnabled"
        :disabled="readOnly"
        name="check-button"
        switch>
        {{ $t("Yes, we use of allowances") }}
      </b-form-checkbox>

      <div v-show="allowancesEnabled">
        <h2 class="questions__subheader">{{ $t("What surcharges apply to you?") }}</h2>
        <b-form-checkbox v-model="allowanceDay" :disabled="readOnly" switch>{{
            $t("Allowances on weekdays / times")
          }}
        </b-form-checkbox>
        <b-form-checkbox v-model="allowanceHoliday" :disabled="readOnly" switch>{{
            $t("Allowances on public holidays")
          }}
        </b-form-checkbox>
        <b-form-checkbox v-model="allowanceOvertime" :disabled="readOnly" switch>{{
            $t("Allowances on overtime")
          }}
        </b-form-checkbox>
      </div>

      <h2 v-if="allowanceDay||allowanceHoliday||allowanceOvertime" class="questions__subheader"><i>{{
          $t("By default, the highest surcharge is applied, do you deviate from this? Indicate this per surcharge.")
        }}</i></h2>

      <h2 v-if="allowanceDay" class="questions__subheader">{{ $t("Allowances on weekdays / times") }}:</h2>
      <div v-if="allowanceDay" class="questions__allowanceDay">
        <p>{{ $t("Allowance name") }}</p>
        <p>{{ $t("Percentage allowance") }}</p>
        <p>{{ $t("Valid on days") }}</p>
        <p>{{ $t("From time to time") }}</p>
        <p>{{ $t("Entire shift") }}</p>
        <p>{{ $t("Contract type") }}</p>
        <p>{{ $t("Type of compensation") }}</p>
        <p></p>

        <template v-for="(allowanceRule, index) in contract.allowanceRules"
                  v-if="allowanceRule.type==='day'">

          <input
            v-model="allowanceRule.name"
            v-b-popover.hover.top="$t('This name appears in the Dyflexis hours overview and becomes the title of the column in which this allowance is tracked.')"
            :disabled="readOnly"
            class="form-control"
            type="text"/>

          <input
            v-model="allowanceRule.surchargeRate"
            v-b-popover.hover.top="$t('Please note, the percentage surcharge is added to the hours worked, a surcharge of 50% therefore means a total compensation of 150%.')"
            :disabled="readOnly"
            class="form-control"
            type="number"/>

          <b-form-checkbox-group
            v-model="allowanceRule.days"
            :disabled="readOnly"
            :options="weekdays"
            switches>
          </b-form-checkbox-group>

          <div>
            <input
              v-model="allowanceRule.startTime"
              :disabled="readOnly"
              class="form-control"
              type="time"/>
            <h2 class="questions__overtimeBetweenLines">t/m</h2>
            <input
              v-model="allowanceRule.endTime"
              :disabled="readOnly"
              class="form-control"
              type="time"/>
          </div>

          <b-form-checkbox
            v-model="allowanceRule.overtime" v-b-popover.hover.top="$t('If this box is checked, you indicate that an employee is entitled to full compensation over his/her entire shift. The start time of the shift must be within the values entered. This also applies if this shift extends beyond the specified times.')"
            :disabled="readOnly"
            switch
          >Ja
          </b-form-checkbox>

          <b-form-checkbox-group
            v-model="allowanceRule.enabledContracts" :disabled="readOnly" switches>
            <template v-for="(contractType) in contract.contractTypes" v-if="contractType.active">
              <b-form-checkbox :disabled="readOnly" :value="contractType.displayName">{{
                  contractType.displayName
                }}
              </b-form-checkbox>
            </template>
          </b-form-checkbox-group>

          <b-form-select v-model="allowanceRule.compensation" v-b-popover.hover.top="$t('Save (TFT) select if you want the allowance to be credited to the employee\'s time-for-time balance. Payout select if you want to pay out the supplement immediately at the end of your remuneration timeframe.')"
                         :disabled="readOnly">
            <b-form-select-option value=timeForTime>{{ $t("Save (TFT)") }}</b-form-select-option>
            <b-form-select-option value="pay">{{ $t("Payout") }}</b-form-select-option>
          </b-form-select>

          <b-button
            :disabled="readOnly"
            class="teammember__delete"
            variant="danger"
            @click="deleteRow(index)">
            {{ $t("Delete") }}
          </b-button>

          <input
            v-model="allowanceRule.conditions"
            :disabled="readOnly"
            :placeholder="$t('If applicable, description of condition, for example: on job or department')"
            class="form-control allowance__condition"
            type="text"/>
        </template>
      </div>

      <b-button
        v-if="allowanceDay"
        :disabled="readOnly"
        class="question--marginTop overtime__addRow"
        variant="success"
        @click="addRowDay">
        <b>+</b> {{ $t("Add day/time allowance") }}
      </b-button>

      <h2 v-if="allowanceHoliday" class="questions__subheader">{{ $t("Allowances on public holidays") }}:</h2>
      <div v-if="allowanceHoliday" class="questions__allowanceDay">
        <p>{{ $t("Allowance name") }}</p>
        <p>{{ $t("Percentage allowance") }}</p>
        <p>{{ $t("Valid on days") }}</p>
        <p>{{ $t("From time to time") }}</p>
        <p>{{ $t("Entire shift") }}</p>
        <p>{{ $t("Contract type") }}</p>
        <p>{{ $t("Type of compensation") }}</p>
        <p></p>

        <template v-for="(allowanceRule, index) in contract.allowanceRules"
                  v-if="allowanceRule.type==='holiday'">

          <input
            v-model="allowanceRule.name"
            v-b-popover.hover.top="$t('This name appears in the Dyflexis hours overview and becomes the title of the column in which this allowance is tracked.')"
            :disabled="readOnly"
            class="form-control"
            type="text"/>

          <input
            v-model="allowanceRule.surchargeRate"
            v-b-popover.hover.top="$t('Please note, the percentage surcharge is added to the hours worked, a surcharge of 50% therefore means a total compensation of 150%.')"
            :disabled="readOnly"
            class="form-control"
            type="number"
          />

          <div>
            <b-form-checkbox-group
              v-model="allowanceRule.holidayActive"
              :disabled="readOnly"
              :options="holidayOptions"
              class="questions--breakLength"
              switches>
            </b-form-checkbox-group>

            <h2 class="questions__overtimeBetweenLines">{{ $t("Manual date") }}:</h2>
            <template v-for="(custom, index) in allowanceRule.holidayCustom">
              <input
                v-model="custom[0]"
                v-b-popover.hover.top="''"
                :disabled="readOnly"
                class="form-control"
                type="date"/>

              <h2 class="questions__overtimeBetweenLines"></h2>

              <b-form-checkbox
                v-model="custom[1]"
                :disabled="readOnly"
                class="questions--breakLength"
                name="check-button"
                switch>
                {{ $t("Repeat annually") }}
              </b-form-checkbox>
            </template>

            <b-button
              :disabled="readOnly"
              class="question--marginTop holidaycustom__addRow"
              variant="success"
              @click="addCustomHoliday(allowanceRule)">
              <b>+</b> {{ $t("Add custom date") }}
            </b-button>
          </div>

          <div>
            <input
              v-model="allowanceRule.startTime"
              v-b-popover.hover.top="''"
              :disabled="readOnly"
              class="form-control"
              type="time"/>
            <h2 class="questions__overtimeBetweenLines">t/m</h2>
            <input
              v-model="allowanceRule.endTime"
              v-b-popover.hover.top="''"
              :disabled="readOnly"
              class="form-control"
              type="time"/>
          </div>

          <b-form-checkbox
            v-model="allowanceRule.overtime"
            v-b-popover.hover.top="$t('If this box is checked, you indicate that an employee is entitled to full compensation over his/her entire shift. The start time of the shift must be within the values entered. This also applies if this shift extends beyond the specified times.')"
            :disabled="readOnly"
            switch
          >{{ $t("Yes") }}
          </b-form-checkbox>

          <b-form-checkbox-group
            v-model="allowanceRule.enabledContracts" :disabled="readOnly"
            switches>
            <template v-for="(contractType) in contract.contractTypes" v-if="contractType.active">
              <b-form-checkbox :disabled="readOnly" :value="contractType.displayName">{{
                  contractType.displayName
                }}
              </b-form-checkbox>
            </template>
          </b-form-checkbox-group>

          <b-form-select v-model="allowanceRule.compensation" v-b-popover.hover.top="$t('Save (TFT) select if you want the allowance to be credited to the employee\'s time-for-time balance. Payout select if you want to pay out the supplement immediately at the end of your remuneration timeframe.')"
                         :disabled="readOnly">
            <b-form-select-option value="timeForTime">{{ $t("Save (TFT)") }}</b-form-select-option>
            <b-form-select-option value="pay">{{ $t("Payout") }}</b-form-select-option>
          </b-form-select>

          <b-button
            :disabled="readOnly"
            class="teammember__delete"
            variant="danger"
            @click="deleteRow(index)">
            {{ $t("Delete") }}
          </b-button>

          <input
            v-model="allowanceRule.conditions"
            :disabled="readOnly"
            :placeholder="$t('If applicable, description of condition, for example: on job or department')"
            class="form-control allowance__condition"
            type="text"/>
        </template>
      </div>

      <b-button
        v-if="allowanceHoliday"
        :disabled="readOnly"
        class="question--marginTop overtime__addRow"
        variant="success"
        @click="addRowHoliday">
        <b>+</b> {{ $t("Add public holiday allowance") }}
      </b-button>

      <h2 v-if="allowanceOvertime" class="questions__subheader">{{ $t("Allowances on overtime") }}:</h2>
      <div v-if="allowanceOvertime" class="questions__allowanceOvertime">
        <p>{{ $t("Allowance name") }}</p>
        <p>{{ $t("Percentage allowance") }}</p>
        <p>{{ $t("Over the period") }}</p>
        <p>{{ $t("Valid from") }}</p>
        <p>{{ $t("Contract type") }}</p>
        <p>{{ $t("For hourtypes") }}</p>
        <p>{{ $t("Type of compensation") }}</p>

        <template v-for="(allowanceRule, index) in contract.allowanceRules" v-if="allowanceRule.type==='overtime'">
          <input
            v-model="allowanceRule.name"
            v-b-popover.hover.top="$t('This name appears in the Dyflexis hours overview and becomes the title of the column in which this allowance is tracked.')"
            :disabled="readOnly"
            class="form-control"
            type="text"/>

          <input
            v-model="allowanceRule.surchargeRate"
            v-b-popover.hover.top="$t('Please note, the percentage surcharge is added to the hours worked, a surcharge of 50% therefore means a total compensation of 150%.')"
            :disabled="readOnly"
            class="form-control"
            type="number"
          />

          <b-form-select v-model="allowanceRule.period" v-b-popover.hover.top="$t('Indicate the period in which the overtime is tracked before being paid.')"
                         :disabled="readOnly">
            <b-form-select-option value=month>{{ $t("Monthly") }}</b-form-select-option>
            <b-form-select-option value="4-weeks">{{ $t("4-weekly") }}</b-form-select-option>
            <b-form-select-option value="week">{{ $t("Weekly") }}</b-form-select-option>
            <b-form-select-option value="day">{{ $t("Day") }}</b-form-select-option>
          </b-form-select>

          <div>
            <b-form-select v-model="allowanceRule.threshold" :disabled="readOnly">
              <b-form-select-option value=contractHours>{{ $t("Contract hours") }}</b-form-select-option>
              <b-form-select-option value="fulltimeContractHours">{{
                  $t("Fulltime contract hours")
                }}
              </b-form-select-option>
              <b-form-select-option value="manualHours">{{ $t("Manual threshold") }}</b-form-select-option>
            </b-form-select>
            <h2 class="questions__overtimeBetweenLines"></h2>
            <input
              v-show="allowanceRule.threshold==='manualHours'"
              v-model="allowanceRule.thresholdHours"
              :disabled="readOnly"
              class="form-control"
              min="0"
              type="number"
            />
          </div>

          <b-form-checkbox-group v-model="allowanceRule.enabledContracts" :disabled="readOnly" switches>
            <template v-for="(contractType) in contract.contractTypes" v-if="contractType.active">
              <b-form-checkbox :disabled="readOnly" :value="contractType.displayName">{{contractType.displayName}}</b-form-checkbox>
            </template>
          </b-form-checkbox-group>

          <b-form-checkbox-group v-model="allowanceRule.calculateForHourTypes" :disabled="readOnly" switches>
            <template v-for="(hourType) in overtimeHourTypes">
              <b-form-checkbox :disabled="readOnly" :value="hourType.value">{{ $t(hourType.value) }}</b-form-checkbox>
            </template>
          </b-form-checkbox-group>

          <b-form-select v-model="allowanceRule.compensation" v-b-popover.hover.top="$t('Save (TFT) select if you want the allowance to be credited to the employee\'s time-for-time balance. Payout select if you want to pay out the supplement immediately at the end of your remuneration timeframe.')"
                         :disabled="readOnly">
            <b-form-select-option value=timeForTime>{{ $t("Save (TFT)") }}</b-form-select-option>
            <b-form-select-option value="pay">{{ $t("Payout") }}</b-form-select-option>
          </b-form-select>

          <b-button
            :disabled="readOnly"
            class="teammember__delete"
            variant="danger"
            @click="deleteRow(index)">
            {{ $t("Delete") }}
          </b-button>

          <input
            v-model="allowanceRule.conditions"
            :disabled="readOnly"
            :placeholder="$t('If applicable, description of condition, for example: on job or department')"
            class="form-control allowance__condition"
            type="text"/>
        </template>
      </div>

      <b-button
        v-if="allowanceOvertime"
        :disabled="readOnly"
        class="question--marginTop overtime__addRow"
        variant="success"
        @click="addRowOvertime()">
        <b>+</b> {{ $t("Add overtime allowance") }}
      </b-button>

      <h2 v-if="allowanceDay||allowanceHoliday||allowanceOvertime" class="questions__subheader"><i>{{
          $t("By default, the highest surcharge is applied, do you deviate from this? Indicate this per surcharge.")
      }}</i></h2>

      <h2 class="questions__subheader">{{ $t("Remarks") }}</h2>
      <b-form-textarea
        v-model="contract.allowanceRemarks"
        :disabled="readOnly"
        class="questions__textarea"
        rows="3"/>

      <input :value="$t('Save')" type="button" @click="handleSave"/>
      <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
    </div>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "../GlobalFunctions";

export default {
  name: "Allowances",
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      contractsEmpty: true,
      allowancesEnabled: false,
      allowanceDay: false,
      allowanceHoliday: false,
      allowanceOvertime: false,
      readOnly: false,
      remarks: null,
      weekdays: [
        {value: 'monday', text: this.$t("Monday")},
        {value: 'tuesday', text: this.$t("Tuesday")},
        {value: 'wednesday', text: this.$t("Wednesday")},
        {value: 'thursday', text: this.$t("Thursday")},
        {value: 'friday', text: this.$t("Friday")},
        {value: 'saturday', text: this.$t("Saturday")},
        {value: 'sunday', text: this.$t("Sunday")},
      ],
      holidayOptions: [
        {value: 'newYear', text: this.$t("New year's day")},
        {value: 'easterMonday', text: this.$t("Easter monday")},
        {value: 'liberationDay', text: this.$t("Liberation day")},
        {value: 'ascensionDay', text: this.$t("Ascension day")},
        {value: 'independenceDay', text: this.$t("Independence day")},
        {value: '1pentecost', text: this.$t("Pentecost")},
        {value: '2pentecost', text: this.$t("Whit monday")},
        {value: '1christmas', text: this.$t("Christmas day")},
        {value: '2christmas', text: this.$t("Boxing day")},
      ],
      overtimeHourTypes: [
        {name: this.$t("Hours worked"), value: 'Hours worked', active: false},
        {name: this.$t("Holiday Hours"), value: 'Holiday Hours', active: false},
        {name: this.$t("TFT leave"), value: 'TFT leave', active: false},
        {name: this.$t("Sickness leave"), value: 'Sickness leave', active: false},
        {name: this.$t("Sickness waiting day"), value: 'Sickness waiting day', active: false},
        {name: this.$t("Paid leave"), value: 'Paid leave', active: false},
        {name: this.$t("Unpaid leave"), value: 'Unpaid leave', active: false},
      ],
      contract: null,
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return false;
    }

    if (result.contracts === null) {
      this.displayFrontend = true;
      return false;
    }

    let contractDecoded;
    try {
      contractDecoded = JSON.parse(result.contracts.replaceAll("&quot;", '"'));
    } catch (e) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      this.displayFrontend = true;
      return false;
    }
    this.contract = contractDecoded;

    this.contract.contractTypes.forEach(
      contract => {
        if (contract.active) {
          this.contractsEmpty = false;
        }
      }
    );

    if (this.contract.allowanceRules) {
      this.contract.allowanceRules.filter(v => v.name !== null).forEach(
        allowanceRule => {
          if (allowanceRule.type === 'holiday' && allowanceRule.name !== '') {
            this.allowanceHoliday = true;
            this.allowancesEnabled = true;

            // Makes it backwards compatible. This can be removed after october 2022
            if (allowanceRule.holidayCustom !== null && !Array.isArray(allowanceRule.holidayCustom)) {
              allowanceRule.holidayCustom = [[allowanceRule.holidayCustom, allowanceRule.holidayCustomRepeating]];
            }

            if (allowanceRule.holidayCustom === null || allowanceRule.holidayCustom === undefined) {
              allowanceRule.holidayCustom = [['', false]];
            }
          }

          if (allowanceRule.type === 'day' && allowanceRule.name !== '') {
            this.allowanceDay = true;
            this.allowancesEnabled = true;
          }

          if (allowanceRule.type === 'overtime' && allowanceRule.name !== '') {
            this.allowanceOvertime = true;
            this.allowancesEnabled = true;
          }
        }
      );
    } else {
      this.contract.allowanceRules = [{
        type: 'day',
        name: '',
        surchargeRate: null,
        days: [],
        startTime: null,
        endTime: null,
        overtime: false,
        enabledContracts: [],
        compensation: 'timeForTime',
        conditions: '',
      }, {
        type: 'holiday',
        name: '',
        surchargeRate: null,
        holidayActive: [],
        startTime: null,
        endTime: null,
        overtime: false,
        holidayCustom: [],
        enabledContracts: [],
        compensation: 'timeForTime',
        conditions: '',
      }, {
        type: 'overtime',
        name: '',
        surchargeRate: null,
        period: null,
        startFromManual: null,
        thresholdHours: null,
        enabledContracts: [],
        calculateForHourTypes: [],
        compensation: 'timeForTime',
        conditions: '',
      }];
    }

    this.readOnly = result.isSigned;
    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.contract));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.contract, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;
      const result = await SystemRequestService.updateProject(this.contract, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.contract));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
    addRowOvertime() {
      this.contract.allowanceRules.push({
        type: 'overtime',
        name: '',
        surchargeRate: null,
        period: null,
        startFromManual: null,
        thresholdHours: null,
        enabledContracts: [],
        calculateForHourTypes: [],
        compensation: 'timeForTime',
        conditions: '',
      });
      this.$forceUpdate();
    },
    addCustomHoliday(allowanceRule) {
      allowanceRule.holidayCustom.push([[null, false]]);
      this.$forceUpdate();
    },
    addRowDay() {
      this.contract.allowanceRules.push({
        type: 'day',
        name: '',
        surchargeRate: null,
        days: [],
        startTime: '00:00',
        endTime: '23:59',
        overtime: false,
        enabledContracts: [],
        compensation: 'timeForTime',
        conditions: '',
      });
      this.$forceUpdate();
    }, addRowHoliday() {
      this.contract.allowanceRules.push({
        type: 'holiday',
        name: '',
        surchargeRate: null,
        holiday: [],
        holidayCustom: [],
        startTime: '00:00',
        endTime: '23:59',
        overtime: false,
        enabledContracts: [],
        compensation: 'timeForTime',
        conditions: '',
      });
      this.$forceUpdate();
    },
    deleteRow(index) {
      this.contract.allowanceRules.splice(index, 1);
      this.$forceUpdate();
    },
  }
};
</script>
